
// chat.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { environment } from 'src/environments/environment';



@Injectable({ providedIn: 'root' })
export class GridService {

  public BaseURL: string = `${environment.baseUrls.serviceURL}`;
  public logOutURL: string = `${environment.baseUrls.serviceSecurity}`;
  public requestData: object = {};
  constructor(private apiService: ApiService, private _http: HttpClient) {}
 
getDistinctValues(yearId: string, columnName: string): Observable<string[]> {
  return this.apiService.get<string[]>(this.BaseURL +`/cmt/PartsComponent/distinctValues/${yearId}/${columnName}`);
}

}
